import { Navigate, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { useAuth } from "@/context/AuthContext";

export default function StudentRoute({ children, requirePasswordSet = true }) {
  const { student, userType, loading, mustChangePassword } = useAuth();
  const location = useLocation();
  const redirectState = useMemo(() => ({ from: location }), [location]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
        <div className="text-slate-500" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }
  if (!student || userType !== "student") {
    return <Navigate to="/login" replace state={redirectState} />;
  }
  if (requirePasswordSet && mustChangePassword) {
    return <Navigate to="/student/set-password" replace />;
  }
  return children;
}
